import React from 'react';
import Row from './Row';
import { Letter } from '../hooks/useWordle';

interface Props {
  currentGuess: string;
  guesses: Letter[][];
  turn: number;
  nbLetters: number;
  guess?: Letter[]; // past guess or undefined
}

const Grid: React.FC<Props> = ({ currentGuess, guesses, turn, nbLetters }) => {
  return (
    <div>
      {guesses.map((g, i) => {
        if (turn === i) {
          return (
            <Row key={i} currentGuess={currentGuess} nbLetters={nbLetters} />
          );
        }
        return <Row key={i} guess={g} nbLetters={nbLetters} />;
      })}
    </div>
  );
};

export default Grid;
